import { appConfig } from '../../../config/customization';
import { xsmall } from '../../../constants/fonts';

const unitStyle = {
  flex: 1,
  padding: '0px 12px',
  justifyContent: 'center',
  minWidth: 50,
  alignItems: 'center'
};

export default {
  container: {
    display: 'flex',
    border: `1px solid ${appConfig.colors.toggleBase}`,
    borderRadius: appConfig.squaredToggle ? 0 : 4,
    fontSize: xsmall,
    fontWeight: 600
  },
  activeSide: {
    ...unitStyle,
    backgroundColor: appConfig.colors.toggleBase,
    color: appConfig.colors.white
  },
  inactiveSide: {
    ...unitStyle,
    color: appConfig.colors.toggleBase,
    fontSize: xsmall
  }
};
